export const globalActivities = Object.freeze({
    1: "Recherche",
    5: "Meeting",
});
export const teamActivities = Object.freeze({
    2: "Entwicklung", 3: "Analyse", 4: "Bugfixing",
});
export const allActivities = Object.freeze({ ...globalActivities, ...teamActivities });

export const dashboardModules = Object.freeze({
    1: "Macroeconomics", 2: "Company", 3: "Product", 4: "Market",
});

export const employmentTypes = Object.freeze({
    0: "Vollzeit", 1: "Teilzeit", 2: "Werkstudent", 3: "Azubi",
});

export const permittedLanguageNames = Object.freeze({
    0: "English", 1: "Deutsch",
});

export const enumToOptions = (enumObject) => Object.entries(enumObject).map(([id, name]) => ({ id, name }));